export default __webpack_public_path__ + "static/media/JavaScript.15a19735.png";